import { styled } from 'styled-components';
import { Divider } from '@idaho-aeyc/ui-kit';

export const SDivider = styled(Divider)``;
